import { Link } from "react-router-dom";

export const NotFound = ({ title = "Page not found", message = "The page you're looking for doesn't exist or may have moved.", testId = "not-found" }) => (
  <div className="max-w-xl mx-auto px-4 py-28 md:py-36 text-center" data-testid={testId}>
    <p className="font-display text-7xl md:text-8xl font-bold text-bm-sand-dark">404</p>
    <h1 className="font-display text-3xl md:text-4xl font-semibold mt-4 text-bm-ink">{title}</h1>
    <p className="text-bm-body mt-3 leading-relaxed">{message}</p>
    <div className="flex justify-center gap-4 mt-8 flex-wrap">
      <Link to="/magazines" data-testid={`${testId}-browse-btn`} className="btn-primary">Browse Magazines</Link>
      <Link to="/" data-testid={`${testId}-home-btn`} className="btn-secondary">Back to Home</Link>
    </div>
  </div>
);
